import { Flex } from 'antd'
import { ColumnType } from 'antd/es/table'
import { useTheme } from 'antd-style'

import {
  PersonInstitutionsHistoryPagedListItem,
  PersonTransferRequestStatus
} from 'src/api/requests'
import { Text } from 'src/components'
import { transferStatusMap } from 'src/features/transfers'
import { dayMonthYearBackSlash, formatDate } from 'src/libs'
import { useLocales } from 'src/locales'

export const useTransferColumns = () => {
  const { t } = useLocales()

  const palette = useTheme()
  const columns: ColumnType<PersonInstitutionsHistoryPagedListItem>[] = [
    {
      key: 'startDate',
      title: t('transfer.start_date'),
      render: ({ startDate }) =>
        startDate ? formatDate(startDate, dayMonthYearBackSlash) : '-'
    },
    {
      key: 'endDate',
      title: t('transfer.end_date'),
      render: ({ endDate }) =>
        endDate ? formatDate(endDate, dayMonthYearBackSlash) : '-'
    },
    {
      key: 'transfer',
      title: t('transfer.transfer'),
      render: ({ transferredToInstitution, institution, status }) => {
        return (
          <Flex vertical>
            <Text color={palette.colorTextTertiary}>{institution?.name}</Text>
            <Text
              color={
                transferStatusMap[status as PersonTransferRequestStatus] ??
                palette.colorText
              }
            >
              {transferredToInstitution ? transferredToInstitution?.name : '-'}
            </Text>
          </Flex>
        )
      }
    }
  ]

  return { columns }
}
